import { useEffect } from 'react'
import {
  useSharedValue,
  withSpring,
  WithSpringConfig,
} from 'react-native-reanimated'
import { ChecklistItemState, getChecklistItemStateValue } from './types'

const useChecklistStateAnimation = (
  state: ChecklistItemState,
  config: WithSpringConfig = {}
) => {
  const animation = useSharedValue(getChecklistItemStateValue(state))

  useEffect(() => {
    animation.set(
      withSpring(getChecklistItemStateValue(state), {
        overshootClamping: true,
        ...config,
      })
    )
  }, [state, animation])

  return animation
}

export default useChecklistStateAnimation
